export const zeroAmountHandlingTypeName = 'zeroAmountHandlingType';
